import React from 'react';
import './login.css';
import logoLogin from '../../images/logo-login.png'
import { Form, FormGroup, Label, Input, Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import UserManager from '../../Core/UserManager';
import HintManager from '../../Core/HintManager';
import {libs,ui} from 'saffroncodejs';
import BimeManager from '../../Core/BimeManager';
import Axios from '../../../node_modules/axios';
import Config from "../../Core/Config";
var StringFunctions = libs.StringFunctions ;
var Preloader = ui.Preloader ;
var MIN_PASSWORD_LENGTH = 6 ;
const id_userRegisterInfo="id_userRegisterInfo";
const id_isResettingPassword="id_isResettingPassword";
const id_enteredCodeTime="id_enteredCodeTime";


class Login extends React.Component {

    enteredCodeTime = 0 ;

    userRegisterInfo = {"Name":"محمدعلي","LName":"دانشور","jens":"26","Email":null,"Address":"خ ميرداماد - م محسني - خ بهروز - بيمه نوين8","Id":"9","Codemelli":"","BimeGozarId":"","BimeShodeId":null,"ActivationCode":"","RegDate":"1397/06/06","RegTime":"16:25","Mobile":"","ErrorMessage":null} ;

    constructor(props) {
        super(props);

        this.userRegisterInfo = {} ;
        
        this.userRegisterInfo = libs.GlobalStorage.load(id_userRegisterInfo);
        this.isResettingPassword = libs.GlobalStorage.load(id_isResettingPassword);
        this.enteredCodeTime = libs.GlobalStorage.load(id_enteredCodeTime);

        UserManager.dispatcher.addEventListner(UserManager.LOGGED_IN,()=>{
            this.resetWaitingForActiveCodeToEnter();
        })

        this.state = {
            username:'',
            password: '',
            
            repassword: '',
            nationalCode: (this.userRegisterInfo!=null)?this.userRegisterInfo.Codemelli:'',
            bimeShodeCode:(this.userRegisterInfo!=null)?this.userRegisterInfo.BimeShodeId:'',
            bimeGozarCode:(this.userRegisterInfo!=null)?this.userRegisterInfo.BimeGozarId:'',
            Mobile:(this.userRegisterInfo!=null)?this.userRegisterInfo.Mobile:'',
            activationCode:'',
            userName:'',
            modal: false,
            redirectToReferrer: false,
            isLoading:false,
            changeMode:false,
            MessageTextPopup:'',
        };
        this.onChange = this.onChange.bind(this);
        this.loginFunction = this.loginFunction.bind(this);
        this.userIsLoggedIn = this.userIsLoggedIn.bind(this);
        this.warnToUser = this.warnToUser.bind(this);
        this.noNet = this.noNet.bind(this);
        this.toggle = this.toggle.bind(this);
        if(UserManager.isLogin())
        {
            UserManager.dispatchStatusEvent();
        }
        
        this.mode =()=>{} ;
        if(this.enteredCodeTime!==null)
        {
            this.openActivationInputPage();
        }
        else
        {
            this.getSetMode(this.defaultLogin);
        }
    }

    toggle() {
        this.setState({
            modal: !this.state.modal,
            isLoading:false
        });
    }
    /** 0: default login - 
     *  1: یاداوری - 
     *  2: ثبت نام جدید - 
     * 2.1:بوسیله کد بیمه شده - 
     * 2.2:بوسیله کد بیمه گذار - 
     */
    getSetMode(newMode=null)
    {
        if(newMode!=null)
        {
            this.mode = newMode.bind(this) ;
            this.setState({changeMode:!this.state.changeMode}) ;
        }
        return this.mode ;
    }



    loginFunction() {

        this.setState({isLoading:true});

        UserManager.dispatcher.addEventListner(UserManager.LOGGED_IN,this.userIsLoggedIn);
        UserManager.dispatcher.addEventListner(UserManager.LOGGIN_ERROR,this.warnToUser);
        UserManager.dispatcher.addEventListner(UserManager.NO_NET,this.noNet);

        UserManager.login(this.state.username,this.state.password);
    }

    componentWillUnmount()
    {
        UserManager.dispatcher.removeEventListner(UserManager.LOGGED_IN,this.userIsLoggedIn);
        UserManager.dispatcher.removeEventListner(UserManager.LOGGIN_ERROR,this.warnToUser);
        UserManager.dispatcher.removeEventListner(UserManager.NO_NET,this.noNet);
    }

    noNet()
    {
        this.setState({isLoading:false});
        HintManager.noInternetConnectionError();
    }

    warnToUser()
    {
        // HintManager.error('نام کاربری و یا رمز عبور صحیح نمی باشد.');
        this.setState({
            modal: true,
            MessageTextPopup:'نام کاربری و یا رمز عبور صحیح نمی باشد.',
        });
        // this.setState({isLoading:false});
    }

    userIsLoggedIn()
    {
        this.setState({isLoading:false});
        // console.log("User logged in");
        //Skip
    }

    onChange(evt) {
         this.setState({ [evt.target.name]: evt.target.value });
     }
    render() {

        var formBody = this.getSetMode()() ;
        let body=<Modal isOpen={this.state.modal} toggle={this.toggle} className="alert_phishnahadha">
                    
                    <ModalBody>
                       {this.state.MessageTextPopup}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggle}>بستن</Button>
                    </ModalFooter>
                </Modal>

        return (

            <div className="login-page">
            {body}
                <div className="container-fluid login-form">
                    <div className="container">
                        <Form>
                            <img onClick={()=>{this.getSetMode(this.defaultLogin)}} alt="" src={logoLogin} />
                            {(!this.state.isLoading)?<span>
                                {formBody}
                                </span>:<Preloader/>
                            }
                        </Form>
                    </div>
                </div>
            </div>
        );
    }




    defaultLogin()
    {
        this.resetWaitingForActiveCodeToEnter();
        return (
        <span>
                
                <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                    <Label className="mr-sm-2">نام کاربری</Label>
                    <Input onChange={(item) => {
                        this.setState({ username: StringFunctions.correctInputString(item.target.value) });
                    }} type="text" name="username" id="username" placeholder="نام کاربری خود را وارد نمایید" value={this.state.username} />
                </FormGroup>
                <FormGroup className="mb-2 mr-sm-2 mb-sm-0" inline>
                    <Label for="password" className="mr-sm-2" >کلمه عبور</Label>
                    <Input onChange={(item) => {
                        this.setState({ password: StringFunctions.correctInputString(item.target.value) });
                    }} type="password" name="password" id="Password" placeholder="کلمه عبور خود را وارد نمایید" value={this.state.password} />
                </FormGroup>
                <div className="buttons">
                    <Button onClick={this.loginFunction}>ورود</Button>
                    <Button onClick={() => {
                        this.isResettingPassword = true;
                        this.getSetMode(this.chooseUserType);
                    }}>یادآوری رمز عبور</Button>
                    <div className="btn-style" onClick={() => {
                        this.isResettingPassword = false;
                        this.getSetMode(this.chooseUserType);
                    }}>ثبت نام جدید</div>
                </div>
        </span>
        )
    }

    chooseUserType()
    {
        return ( <span>
                    <div className="buttons">
                        {this.isResettingPassword?<div className="help">نحوه بازیابی رمز عبور خود را انتخاب کنید</div>:<div className="help">ثبت نام</div>}
                        <br/>
                        <Button onClick={()=>{this.getSetMode(this.registerByBimeShode)}}>بوسیله کد بیمه شده</Button>
                        <Button onClick={()=>{this.getSetMode(this.registerByBimeGozar)}}>بوسیله کد بیمه گذار</Button>
                        <br />
                        <br />
                        <div className="btn-style"  onClick={()=>{this.getSetMode(this.defaultLogin)}}>بازگشت</div>
                    </div>
                </span>
        )
    }

        registerByBimeShode()
        {
            return (<span>
                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                        <Label className="mr-sm-2">کد ملّی</Label>
                        <Input onChange={(item)=>{
                            this.setState({nationalCode : StringFunctions.correctInputString(item.target.value)});
                        }} pattern="[0-9]*"  name="nationalCode" id="nationalCode" placeholder="" value={this.state.nationalCode}  />
                    </FormGroup>
                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0" inline>
                        <Label for="bimeShodeCode" className="mr-sm-2" >کد بیمه شده</Label>
                        <Input onChange={(item)=>{
                            this.setState({bimeShodeCode : StringFunctions.correctInputString(item.target.value)});
                        }} pattern="[0-9]*" name="bimeShodeCode" id="bimeShodeCode" placeholder="" value={this.state.bimeShodeCode}  />
                    </FormGroup>
                    <div className="buttons">
                        <Button onClick={()=>{this.registerUser("",this.state.nationalCode,"",this.state.bimeShodeCode)}}>تایید و ادامه</Button>
                        <div className="btn-style" onClick={()=>{this.getSetMode(this.defaultLogin)}}>بازگشت</div>
                    </div>
                </span>
            )
        }

        registerByBimeGozar()
        {
            return (<span>
                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                        <Label className="mr-sm-2">کد ملّی</Label>
                        <Input onChange={(item)=>{
                            this.setState({nationalCode : StringFunctions.correctInputString(item.target.value)});
                        }} pattern="[0-9]*" name="nationalCode" id="nationalCode" placeholder="" value={this.state.nationalCode}  />
                    </FormGroup>
                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0" inline>
                        <Label for="bimeGozarCode" className="mr-sm-2" >کد بیمه گذار</Label>
                        <Input onChange={(item)=>{
                            this.setState({bimeGozarCode : StringFunctions.correctInputString(item.target.value)});
                        }} pattern="[0-9]*" name="bimeGozarCode" id="bimeGozarCode" placeholder="" value={this.state.bimeGozarCode}  />
                    </FormGroup>
                    <div className="buttons">
                    <Button onClick={()=>{this.registerUser(this.state.bimeGozarCode,this.state.nationalCode,"","")}}>تایید و ادامه</Button>
                        <div className="btn-style" onClick={()=>{this.getSetMode(this.defaultLogin)}}>بازگشت</div>
                    </div>
                </span>
            ) 
        }

        registerUser(bimeGozar="",melliCode="",mobile="",bimeShode='')
        {
            this.setState({isLoading:true});
            if(this.isResettingPassword){
                console.log('resetpass');
                Axios.get(Config.domain_pic+"/V2/CheckPostalCode?postalCode="+this.state.nationalCode)
                .then((result3)=>{
                    if(result3.data.Result){
                                Axios.post(BimeManager.reactRedirectDomain1,
                                    BimeManager.makeBody("/api/UserApi/Register",
                                    {
                                        bimeGozarId:bimeGozar,
                                        bimeShodeId:bimeShode,
                                        phoneNumber:mobile,
                                        nationalCode:melliCode,
                                        ActivationCode:""
                                        
                                    }
                                ),
                                BimeManager.header())
                                .then((result3)=>{
                                    
                                    if(result3.data.ErrorMessage!==null)
                                    {
                                        // HintManager.error(result.data.ErrorMessage);
                                        this.setState({
                                            modal: !this.state.modal,
                                            MessageTextPopup:result3.data.ErrorMessage

                                        });
                                    }
                                    else
                                    {
                                        this.userRegisterInfo = result3.data ;
                                        this.enteredCodeTime = new Date().getTime();
                                        libs.GlobalStorage.save(id_userRegisterInfo,this.userRegisterInfo);
                                        libs.GlobalStorage.save(id_isResettingPassword,this.isResettingPassword);
                                        libs.GlobalStorage.save(id_enteredCodeTime,this.enteredCodeTime);
                                        
                                        if(result3.data.ErrorMessage!==null)
                                            // HintManager.error(result.data.ErrorMessage.split('100-').join(''));
                                            this.setState({
                                                modal: true,
                                                MessageTextPopup:result3.data.ErrorMessage.split('100-').join(''),
                                            });
                                        this.openActivationInputPage();
                                    }
                                    /*else{//Foor registration
                    
                                    }*/
                                    this.setState({isLoading:false,Mobile:result3.data.Mobile});
                                })
                                .catch((error)=>{
                                    
                                    this.setState({isLoading:false});
                                });
                            }
                            else{
                                // HintManager.error('شما قبلا ثبت نام نکرده اید امکان بازیابی رمزعبور برای شما وجود ندارد');
                                Axios.post(BimeManager.reactRedirectDomain1,
                                    BimeManager.makeBody("/api/UserApi/Register",
                                    {
                                        bimeGozarId:bimeGozar,
                                        bimeShodeId:bimeShode,
                                        phoneNumber:mobile,
                                        nationalCode:melliCode,
                                        ActivationCode:""
                                        
                                    }
                                ),
                                BimeManager.header())
                                .then((result3)=>{
                                    
                                    if(result3.data.ErrorMessage!==null)
                                    {
                                        // HintManager.error(result.data.ErrorMessage);
                                        this.setState({
                                            modal: !this.state.modal,
                                            MessageTextPopup:result3.data.ErrorMessage

                                        });
                                    }
                                    else
                                    {
                                        this.setState({
                                            modal: !this.state.modal,
                                            MessageTextPopup:'شما قبلا ثبت نام نکرده اید امکان بازیابی رمزعبور برای شما وجود ندارد',
                                            isLoading:false
        
                                        });
                                    }
                                })
                                

                                /////////////////////////////////////
                                
                                    
                               
                            }
                        });
            }
            else{
                console.log('register');
                Axios.get(Config.domain_pic+"/V2/CheckPostalCode?postalCode="+this.state.nationalCode)
                .then((result2)=>{
                    console.log(result2.data);
                    console.log(result2.data.Result);
                    if(result2.data.Result){
                        // HintManager.error('شما قبلا ثبت نام کرده اید امکان ثبت نام مجدد وجود ندارد');
                        // this.setState({isLoading:false});
                        this.setState({
                            modal: true,
                            MessageTextPopup:'شما قبلا ثبت نام کرده اید امکان ثبت نام مجدد وجود ندارد',
                            

                        });
                        
                    }else{
                        console.log("api");
                        Axios.post(BimeManager.reactRedirectDomain1,
                            BimeManager.makeBody("/api/UserApi/Register",
                            {
                                bimeGozarId:bimeGozar,
                                bimeShodeId:bimeShode,
                                phoneNumber:mobile,
                                nationalCode:melliCode,
                                ActivationCode:""
                                
                            }
                        ),
                        BimeManager.header())
                        .then((result2)=>{
                            if(result2.data.ErrorMessage!==null)
                            {
                                // HintManager.error(result2.data.ErrorMessage);
                                this.setState({
                                    modal: true,
                                    MessageTextPopup:result2.data.ErrorMessage,
                                });
                            }
                            else
                            {
                                this.userRegisterInfo = result2.data ;
                                this.enteredCodeTime = new Date().getTime();
                                libs.GlobalStorage.save(id_userRegisterInfo,this.userRegisterInfo);
                                libs.GlobalStorage.save(id_isResettingPassword,this.isResettingPassword);
                                libs.GlobalStorage.save(id_enteredCodeTime,this.enteredCodeTime);
                                
                                if(result2.data.ErrorMessage!==null)
                                    HintManager.error(result2.data.ErrorMessage.split('100-').join(''));
            
                                this.openActivationInputPage();
                            }
                            /*else{//Foor registration
            
                            }*/
                            this.setState({isLoading:false,Mobile:result2.data.Mobile});
                        })
                        .catch((error)=>{
                            
                            this.setState({isLoading:false});
                        });
                    }
                                        
            });
            
        }
    }


        openActivationInputPage()
        {
            if(this.isResettingPassword)
            {
                //For recovery
                // HintManager.error("کد بازیابی رمز عبور برای شما پیامک شد.");
                this.setState({
                    modal: !this.state.modal,
                    MessageTextPopup:'کد بازیابی رمز عبور برای شما پیامک شد.',
                    // isLoading:false

                });
                this.getSetMode(this.enterActivationCodeAndNewPasswords);
            }   
            else
            {
                this.getSetMode(this.enterCode);
            }
        }

        resetWaitingForActiveCodeToEnter()
        {
            this.enteredCodeTime = null ;
            libs.GlobalStorage.save(id_enteredCodeTime,this.enteredCodeTime);
        }




            enterActivationCodeAndNewPasswords()
            {
                return (<span>

                    <div className="help">کد فعال سازی برای شما پیامک شده است. دریافت آن ممکن است کمی زمانبر باشد. لطفا پس از دریافت، آن را در قسمت مربوطه وارد نموده و رمز عبور جدید را وارد نمایید.</div>
                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                        <Label className="mr-sm-2">کد فعال سازی</Label>
                        <Input onChange={(item)=>{
                            this.setState({activationCode : StringFunctions.correctInputString(item.target.value)});
                        }} type="text" pattern="[\d+]{0,11}" name="activationCode" id="activationCode" placeholder="" value={this.state.activationCode}  />
                    </FormGroup>
                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0" inline>
                        <Label for="password" className="mr-sm-2" >رمز عبور جدید</Label>
                        <Input onChange={(item)=>{
                            this.setState({password : StringFunctions.correctInputString(item.target.value)});
                        }} type="password" name="password" id="password" placeholder="" value={this.state.password}  />
                    </FormGroup>
                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0" inline>
                        <Label for="repassword" className="mr-sm-2" >تکرار رمز عبور</Label>
                        <Input onChange={(item)=>{
                            this.setState({repassword : StringFunctions.correctInputString(item.target.value)});
                        }} type="password" name="repassword" id="repassword" placeholder="" value={this.state.repassword}  />
                    </FormGroup>
                    <div className="buttons">
                        <Button onClick={()=>{
                            if(this.state.repassword!==this.state.password)
                            {
                                // HintManager.error("رمز عبور تکرار شده اشتباه است");
                                this.setState({
                                    modal: true,
                                    MessageTextPopup:"رمز عبور تکرار شده اشتباه است",
                                });
                            }
                            else if(this.state.password.length<MIN_PASSWORD_LENGTH)
                            {
                                // HintManager.error("طول رمز عبور حد اقل باید "+MIN_PASSWORD_LENGTH+" کاراکتر باشد");
                                this.setState({
                                    modal: true,
                                    MessageTextPopup:"طول رمز عبور حد اقل باید "+MIN_PASSWORD_LENGTH+" کاراکتر باشد",
                                });
                            }
                            else
                            {
                                this.resetPassord(this.state.Mobile,this.state.password,this.state.nationalCode,this.state.activationCode);
                            }
                        }}>تایید و ادامه</Button>
                        <div className="btn-style" onClick={()=>{this.getSetMode(this.defaultLogin)}}>بازگشت</div>
                    </div>
                </span>
            ) 
            }

            
            enterCode()
            {
                return (<span>
                    <div className="help">کد فعال سازی برای شما پیامک شده است. دریافت آن ممکن است کمی زمانبر باشد. لطفا پس از دریافت، آن را در قسمت مربوطه وارد نموده و رمز عبور جدید را وارد نمایید.</div>
                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                        <Label className="mr-sm-2">کد فعال سازی</Label>
                        <Input onChange={(item)=>{
                            this.setState({activationCode : StringFunctions.correctInputString(item.target.value)});
                        }} type="text" pattern="[\d+]{0,11}" name="activationCode" id="activationCode" placeholder="" value={this.state.activationCode}  />
                    </FormGroup>
                    <div className="buttons">
                        <Button onClick={()=>{
                            if(this.state.activationCode.length===0)
                            {
                                // HintManager.error("لطفا کد دریافتی را وارد نمایید.");
                                this.setState({
                                    modal: !this.state.modal,
                                    MessageTextPopup:'لطفا کد دریافتی را وارد نمایید.',
                                    // isLoading:false
                
                                });
                            }
                            else
                            {
                                this.onActivateCodeEntered();
                            }
                        }}>تایید و ادامه</Button>
                        <Button onClick={()=>{
                            const waitTimeInSeconds = 60 ;
                            var deltaTimeInSecond = Math.ceil((new Date().getTime()-this.enteredCodeTime)/1000) ;
                            if(deltaTimeInSecond<waitTimeInSeconds)
                            {
                                // HintManager.error((waitTimeInSeconds-deltaTimeInSecond)+"ثانیه دیگر صبر کنید.");
                                this.setState({
                                    modal: !this.state.modal,
                                    MessageTextPopup:(waitTimeInSeconds-deltaTimeInSecond)+"ثانیه دیگر صبر کنید.",
                                    // isLoading:false
                
                                });
                            }
                            else
                            {
                                this.registerUser(this.state.bimeGozarCode,this.state.nationalCode,'',this.state.bimeShodeCode);
                            }
                        }}>درخواست مجدد کد</Button>
                        <div className="btn-style" onClick={()=>{this.getSetMode(this.defaultLogin)}}>بازگشت</div>
                    </div>
                </span>
            ) 
            }

            onActivateCodeEntered()
            {
                this.setState({isLoading:true});
                Axios.post(BimeManager.reactRedirectDomain1,
                    BimeManager.makeBody("/api/UserApi/CheckActivationCode",
                    {
                        ActivationCode:this.state.activationCode,
                        phoneNumber:'',
                        bimeGozarId:'',
                        bimeShodeId:'',
                        nationalCode:this.state.nationalCode,
                    }
                ),
                BimeManager.header())
                .then((result)=>{
                    var activationResult = {"Name":null,"LName":null,"jens":null,"Email":null,"Address":null,"Id":null,"Codemelli":"0451636155","BimeGozarId":null,"BimeShodeId":null,"ActivationCode":null,"RegDate":null,"RegTime":null,"Mobile":null,"ErrorMessage":"True"};
                    activationResult = result.data ;
                    if(activationResult!=null && activationResult.ErrorMessage === "False")
                    {
                        this.getSetMode(this.registerCurrentUser);
                    }
                    else
                    {
                        // HintManager.error("کد وارد شده صحیح نمی باشد");
                        this.setState({
                            modal: !this.state.modal,
                            MessageTextPopup:"کد وارد شده صحیح نمی باشد",
                            // isLoading:false
        
                        });
                    }

                    this.setState({isLoading:false});
                })
                .catch((err)=>{
                    HintManager.noInternetConnectionError();
                    this.setState({isLoading:false});
                })
            }


            registerCurrentUser()
            {
                return (<span>
                            <div className="help">لطفا برای حساب کاربری خود یک نام کاربری و یک رمز عبور ثبت کنید</div>
                            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                                <Label className="mr-sm-2">نام کاربری</Label>
                                <Input onChange={(item)=>{
                                    this.setState({userName : StringFunctions.correctInputString(item.target.value)});
                                }} type="text" name="userName" id="userName" placeholder="" value={this.state.userName}  />
                            </FormGroup>
                            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                                <Label className="mr-sm-2">رمز عبور</Label>
                                <Input onChange={(item)=>{
                                    this.setState({password : StringFunctions.correctInputString(item.target.value)});
                                }} type="password" name="password" id="password" placeholder="" value={this.state.password}  />
                            </FormGroup>
                            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                                <Label className="mr-sm-2">تکرار رمز عبور</Label>
                                <Input onChange={(item)=>{
                                    this.setState({repassword : StringFunctions.correctInputString(item.target.value)});
                                }} type="password" name="repassword" id="repassword" placeholder="" value={this.state.repassword}  />
                            </FormGroup>
                            <div className="buttons">
                                <Button onClick={()=>{

                                    this.registerProgress();

                                }}>ثبت نام</Button>
                                <div onClick={()=>{this.getSetMode(this.defaultLogin)}}>بازگشت</div>
                            </div>
                        </span>
                    ) 
            }

            registerProgress()
            {
                this.setState({isLoading:true});
                //UserManager.dispatcher.addEventListner(UserManager.REGISTER_DONE,onRegisterDone);
                UserManager.dispatcher.addEventListner(UserManager.REGISTER_ERROR,onRegisterFail);
                UserManager.dispatcher.addEventListner(UserManager.NO_NET,noNetToRegister);
                UserManager.regster(this.userRegisterInfo.Name,this.userRegisterInfo.LName,this.userRegisterInfo.Codemelli+'@fake.com','0',this.userRegisterInfo.Address,this.userRegisterInfo.Mobile,this.state.userName,this.state.password,null,this.userRegisterInfo.jens!==27,'-',this.userRegisterInfo.Codemelli)

                var currentComponent = this ;

                function onRegisterFail(event,message)
                {
                    currentComponent.setState({isLoading:false});
                    HintManager.error(message);
                    UserManager.dispatcher.removeEventListner(UserManager.REGISTER_ERROR,onRegisterFail);
                    UserManager.dispatcher.removeEventListner(UserManager.NO_NET,noNetToRegister);
                    currentComponent.getSetMode(currentComponent.defaultLogin);
                }

                function noNetToRegister(event,message)
                {
                    currentComponent.setState({isLoading:false});
                    HintManager.noInternetConnectionError();
                    UserManager.dispatcher.removeEventListner(UserManager.REGISTER_ERROR,onRegisterFail);
                    UserManager.dispatcher.removeEventListner(UserManager.NO_NET,noNetToRegister);
                }
            }






            resetPassord(MobileNo="",NewPassword="",nationalCode="",confirmCode="")
            {
                this.setState({isLoading:true});
                //nationalCode=0451636155&confirmCode=857527&NewPassword=123456&MobileNo=09126654136
                Axios.post(BimeManager.reactRedirectDomain1,
                    BimeManager.makeBody("/api/UserApi/ResetPassword",
                    {
                        nationalCode: nationalCode,
                        confirmCode:  confirmCode,
                        NewPassword:  NewPassword,
                        MobileNo:  MobileNo,
                    }
                ),
                BimeManager.header())
                .then((result)=>{
                    result = BimeManager.encodeResult(result)
                    this.setState({isLoading:false});
                    if(result.data.toString()==="tuser==null")
                    {
                        // HintManager.error("شما قبلا در سیستم ثبت نام نشده اید. لطفا ابتدا به بخش ثبت نام مراجعه فرمایید.");
                        this.setState({
                            modal: !this.state.modal,
                            MessageTextPopup:"شما قبلا در سیستم ثبت نام نشده اید. لطفا ابتدا به بخش ثبت نام مراجعه فرمایید.",
                            // isLoading:false
        
                        });
                    }
                    else if(result.data==="-1")
                    {
                        // HintManager.error("کد فعال سازی وارد شده صحیح نیست.");
                        this.setState({
                            modal: !this.state.modal,
                            MessageTextPopup:"کد فعال سازی وارد شده صحیح نیست.",
                            // isLoading:false
        
                        });
                    }
                    else
                    {
                        // HintManager.error("رمز عبور شما به درستی تغییر یافت");
                        this.setState({
                            modal: !this.state.modal,
                            MessageTextPopup:"رمز عبور شما به درستی تغییر یافت",
                            // isLoading:false
        
                        });
                        this.getSetMode(this.defaultLogin);
                    }
                })
                .catch((err)=>{
                    HintManager.noInternetConnectionError();
                    this.setState({isLoading:false});
                })
            }

}






export { Login };


// WEBPACK FOOTER //
// ./src/components/Login/login.js